export const FOLA_HEADER_ROW_CLASS = "flex items-center gap-3";

export const FOLA_COMPACT_HEADER_ROW_CLASS = "flex items-center gap-2";

export const FOLA_ICON_CLASS = "h-5 w-5 shrink-0 self-center";

export const FOLA_LABEL_CLASS = "text-label-medium leading-none text-on-surface-var";

export const FOLA_TITLE_CLASS = "text-title-small font-medium text-primary";

export const FOLA_ACTION_ROW_CLASS = "mt-3 flex flex-wrap gap-2";

export const FOLA_PRIMARY_CTA_CLASS = "h-10 px-4";

export const FOLA_SECONDARY_CTA_CLASS =
  "h-10 px-4 text-label-large text-primary bg-[rgba(77,163,255,0.08)] hover:bg-[rgba(77,163,255,0.14)]";

export const FOLA_TONAL_DRAFT_CARD_CLASS =
  "mt-3 rounded-[12px] border border-[rgba(29,79,215,0.12)] bg-[var(--state-primary-12)] p-4 shadow-none";
